<template>
  <div class="h-full w-full flex flex-col items-center grow overflow-y-hidden">
    <div class="w-full flex flex-col grow overflow-y-auto">
      <Feed
        variant="activity_log"
        :items="feed"
        :task="task"
        class="grow overflow-y-auto"
      />
      <span
        v-if="hasNextPage && !isFetching"
        ref="loadMore"
        class="relative w-full"
      />
    </div>
  </div>
</template>

<script setup>
import { onUnmounted, ref } from "vue";
import { useIntersectionObserver } from "@vueuse/core";
import { Feed } from "@/SharedComponents/Feed";
import { useActivityHistory } from "@/Composables/useActivityHistory";

const loadMore = ref(null);

const props = defineProps({
  task: { type: Object, required: true },
  feed: { type: Array, default: () => [] },
});

const { fetchNextPage, hasNextPage, isFetching } = useActivityHistory(
  props.task.tenant.id,
  props.task
);

const { stop } = useIntersectionObserver(loadMore, ([{ isIntersecting }]) => {
  if (isIntersecting && !isFetching.value) {
    fetchNextPage.value();
  }
});

onUnmounted(() => {
  stop();
});
</script>
